(function () {
  'use strict';
  if (window.zrCollectorReady) return;
  window.zrCollectorReady = true;
  var KEY = 'zrFavorites.v1', LIMIT = 100, PAGE = 12;
  var dialog, list, entries = [], persistent = true, lastFocus, visibleCount = PAGE;
  var generation = 0, controllers = new Set(), scheduled = false;
  function validHandle(value) { return typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,199}$/.test(value); }
  function normalize(value) {
    if (!Array.isArray(value)) return [];
    var seen = new Set();
    return value.filter(function (item) {
      if (!item || !validHandle(item.handle) || seen.has(item.handle)) return false;
      seen.add(item.handle); return true;
    }).slice(0, LIMIT).map(function (item) { return {handle:item.handle, title:String(item.title || item.handle).slice(0,300)}; });
  }
  function read() {
    try { entries = normalize(JSON.parse(localStorage.getItem(KEY) || '[]')); }
    catch (error) { entries = []; }
  }
  function announce(message) {
    var el = document.querySelector('[data-zr-favorites-announcement]');
    if (el) el.textContent = message;
  }
  function write() {
    try { localStorage.setItem(KEY, JSON.stringify(entries)); persistent = true; }
    catch (error) { persistent = false; }
    sync();
  }
  function sync() {
    var saved = new Set(entries.map(function (item) { return item.handle; }));
    document.querySelectorAll('[data-zr-favorite-toggle]').forEach(function (button) {
      if (!validHandle(button.dataset.handle)) return;
      var active = saved.has(button.dataset.handle), title = button.dataset.title || 'artwork';
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + title + (active ? ' from favorites' : ' to favorites'));
      var label = button.querySelector('[data-zr-favorite-label]');
      if (label && label.textContent !== (active ? 'Saved artwork' : 'Save artwork')) label.textContent = active ? 'Saved artwork' : 'Save artwork';
    });
    document.querySelectorAll('[data-zr-favorites-count]').forEach(function (el) { if (el.textContent !== String(entries.length)) el.textContent = entries.length; el.hidden = entries.length === 0; });
    document.querySelectorAll('[data-zr-favorites-open]').forEach(function (el) { el.hidden = false; });
  }
  function abortRequests() {
    generation++;
    controllers.forEach(function (controller) { controller.abort(); });
    controllers.clear();
  }
  function emptyState() {
    dialog.querySelector('[data-zr-favorites-empty]').hidden = entries.length !== 0;
    dialog.querySelector('[data-zr-favorites-more]').hidden = entries.length <= visibleCount;
    dialog.querySelector('[data-zr-favorites-status]').textContent = entries.length ? entries.length + (entries.length === 1 ? ' saved artwork.' : ' saved artworks.') + (persistent ? '' : ' Saved for this visit only; browser storage is unavailable.') : '';
  }
  function fallback(item, unavailable) {
    var card = document.createElement('article'); card.className = 'zr-favorite-item'; card.dataset.handle = item.handle;
    var body = document.createElement('div'); body.className = 'zr-favorite-item__body';
    var title = document.createElement('h3'); title.textContent = item.title;
    var message = document.createElement('p'); message.textContent = unavailable ? 'This artwork is no longer available online.' : 'Details could not load. Please try again.';
    var actions = document.createElement('div'); actions.className = 'zr-favorite-item__actions';
    if (!unavailable) {
      var retry = document.createElement('button'); retry.type = 'button'; retry.dataset.zrFavoriteRetry = item.handle; retry.textContent = 'Try again'; actions.appendChild(retry);
    }
    var remove = document.createElement('button'); remove.type = 'button'; remove.dataset.zrFavoriteRemove = ''; remove.dataset.handle = item.handle; remove.textContent = 'Remove'; remove.setAttribute('aria-label','Remove ' + item.title + ' from favorites'); actions.appendChild(remove);
    body.append(title,message,actions); card.appendChild(body); return card;
  }
  async function loadCard(item, placeholder, token) {
    var controller = new AbortController(); controllers.add(controller);
    var timeout = window.setTimeout(function () { controller.abort(); },12000);
    try {
      var url = new URL(dialog.dataset.productsRoot + encodeURIComponent(item.handle), location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid product URL');
      url.searchParams.set('view','zr-favorite');
      var preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id',preview);
      var response = await fetch(url.pathname + url.search,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
      if (token !== generation || !dialog.open) return;
      if (response.status === 404) { placeholder.replaceWith(fallback(item,true)); return; }
      if (!response.ok) throw new Error('Unavailable');
      var doc = new DOMParser().parseFromString(await response.text(),'text/html');
      var card = doc.querySelector('[data-zr-favorite-item]');
      if (!card || card.dataset.handle !== item.handle) throw new Error('Invalid product response');
      // Only the product fragment from this theme is inserted. Names in it are escaped by Liquid.
      card.querySelectorAll('script,iframe,object,embed').forEach(function (el) { el.remove(); });
      if (token === generation && dialog.open && placeholder.isConnected) placeholder.replaceWith(card);
    } catch (error) {
      if (token === generation && dialog.open && placeholder.isConnected) placeholder.replaceWith(fallback(item,false));
    } finally { clearTimeout(timeout); controllers.delete(controller); }
  }
  async function render() {
    if (!dialog || !dialog.open) return;
    abortRequests(); var token = generation;
    list.replaceChildren(); emptyState();
    var jobs = entries.slice(0,visibleCount).map(function (item) {
      var placeholder = document.createElement('article'); placeholder.className = 'zr-favorite-item zr-favorite-item--loading'; placeholder.textContent = 'Loading ' + item.title + '…'; list.appendChild(placeholder);
      return {item:item,placeholder:placeholder};
    });
    var next = 0;
    async function worker() {
      while (next < jobs.length && token === generation && dialog.open) {
        var job = jobs[next++]; await loadCard(job.item,job.placeholder,token);
      }
    }
    await Promise.all([worker(),worker(),worker()]);
  }
  function remove(handle) {
    entries = entries.filter(function (item) { return item.handle !== handle; }); write();
    announce('Artwork removed from favorites.');
    if (dialog.open) {
      // Keep focus in a stable place when its Remove button disappears.
      dialog.querySelector('[data-zr-favorites-close]').focus({preventScroll:true}); render();
    }
  }
  function enhanceBuilder() {
    if (!dialog) return;
    document.querySelectorAll('[data-zr-builder-card]').forEach(function (card) {
      if (card.querySelector('[data-zr-favorite-toggle]')) return;
      var link = card.querySelector('h2 a'), body = card.querySelector('.zr-builder-card__body');
      if (!link || !body || !link.getAttribute('href')) return;
      var match;
      try { var url = new URL(link.href,location.href); if (url.origin !== location.origin) return; match = url.pathname.match(/\/products\/([a-z0-9][a-z0-9-]*)\/?$/); } catch (error) { return; }
      if (!match || !validHandle(match[1])) return;
      var button = document.createElement('button'); button.type = 'button'; button.className = 'zr-favorite-button'; button.dataset.zrFavoriteToggle = ''; button.dataset.handle = match[1]; button.dataset.title = link.textContent.trim();
      var heart = document.createElement('span'); heart.textContent = '♡'; heart.setAttribute('aria-hidden','true');
      var label = document.createElement('span'); label.dataset.zrFavoriteLabel = ''; label.textContent = 'Save artwork'; button.append(heart,label);
      body.insertBefore(button,body.querySelector('form'));
    });
  }
  function initConvention(root) {
    root.querySelectorAll('[data-zr-convention]').forEach(function (area) {
      var select = area.querySelector('[data-zr-convention-event]');
      var tags = area.querySelector('input[name="contact[tags]"]');
      if (!select || !tags || select.dataset.ready) return;
      select.dataset.ready = 'true'; area.querySelector('[data-zr-convention-event-wrap]').hidden = false;
      var requested = new URL(location.href).searchParams.get('zr_event');
      if (requested && Array.from(select.options).some(function (option) { return option.value === requested; })) select.value = requested;
      function update() { tags.value = 'prospect,newsletter,zr-convention-signup' + (validHandle(select.value) ? ',zr-event-' + select.value : ''); }
      select.addEventListener('change',update); update();
    });
  }
  function init() {
    dialog = document.querySelector('[data-zr-favorites]');
    initConvention(document);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    list = dialog.querySelector('[data-zr-favorites-list]'); read(); enhanceBuilder(); sync();
    document.addEventListener('click',function (event) {
      var target = event.target.closest && event.target.closest('[data-zr-favorite-toggle],[data-zr-favorites-open],[data-zr-favorites-close],[data-zr-favorite-remove],[data-zr-favorite-retry],[data-zr-favorites-more]');
      if (!target) return;
      event.preventDefault();
      if (target.hasAttribute('data-zr-favorite-toggle')) {
        var handle = target.dataset.handle; if (!validHandle(handle)) return;
        if (entries.some(function (item) { return item.handle === handle; })) { remove(handle); return; }
        if (entries.length >= LIMIT) { announce('Your favorites are full. Remove an artwork to save another.'); return; }
        entries.unshift({handle:handle,title:String(target.dataset.title || handle).slice(0,300)}); write();
        announce(persistent ? 'Artwork saved to favorites.' : 'Artwork saved for this visit. Your browser could not save it for later.');
        return;
      }
      if (target.hasAttribute('data-zr-favorites-open')) {
        document.dispatchEvent(new CustomEvent('zr:overlay-opening',{detail:{source:'favorites'}}));
        lastFocus = target; visibleCount = PAGE; dialog.hidden = false;
        dialog.showModal(); document.body.classList.add('zr-favorites-open'); render(); return;
      }
      if (target.hasAttribute('data-zr-favorites-close')) { dialog.close(); return; }
      if (target.hasAttribute('data-zr-favorite-remove')) { remove(target.dataset.handle); return; }
      if (target.hasAttribute('data-zr-favorite-retry')) {
        var item = entries.find(function (entry) { return entry.handle === target.dataset.zrFavoriteRetry; });
        if (item) { target.disabled = true; loadCard(item,target.closest('.zr-favorite-item'),generation); }
        return;
      }
      if (target.hasAttribute('data-zr-favorites-more')) { visibleCount += PAGE; render(); }
    });
    dialog.addEventListener('close',function () {
      abortRequests(); dialog.hidden = true; document.body.classList.remove('zr-favorites-open');
      if (lastFocus && lastFocus.isConnected) lastFocus.focus({preventScroll:true});
    });
    dialog.addEventListener('click',function (event) {
      if (event.target !== dialog) return;
      var rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    window.addEventListener('storage',function (event) {
      if (event.key === KEY || event.key === null) { read(); sync(); if (dialog.open) render(); }
    });
    window.addEventListener('pageshow',function (event) { if (event.persisted && persistent) { read(); sync(); } });
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; enhanceBuilder(); sync(); });
    }).observe(document.getElementById('PageContainer') || document.body,{childList:true,subtree:true});
  }
  document.addEventListener('shopify:section:load',function () { initConvention(document); if (dialog) { enhanceBuilder(); sync(); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
}());
